import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-discussion-input',
  templateUrl: './discussion-input.component.html',
  styleUrls: ['./discussion-input.component.scss'],
})
export class DiscussionInputComponent implements OnInit {
  message = '';

  @Input()
  id: any;

  constructor(public messageService: MessageService) {}

  ngOnInit() {}
}
